import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { svgIcons } from '../UI/SvgIcons';
import { logoutUser } from '@/utility/helper';
import { useAppDispatch, useAppSelector } from '@/redux/store';
import { fetchNotificationCount } from '@/redux/features/UserSlice';
const { NotificationIcon } = svgIcons;

const Header: React.FC = () => {
  const dispatch = useAppDispatch();
  const notificationCount = useAppSelector(
    (state) => state?.user?.notificationCount,
  );
  useEffect(() => {
    dispatch(fetchNotificationCount());
  }, []);

  // console.log(notificationCount);
  return (
    <>
      <header className="w-full bg-white flex items-center justify-between px-5 sm:px-8 py-3 sm:py-5 rounded-full">
        <Link to={'/'} className="flex items-center space-x-2">
          <img
            src="/assets/images/logo.svg"
            alt="Logo"
            className="h-5 sm:h-8 w-auto"
          />
        </Link>

        <div className="flex items-center space-x-6">
          <Link
            to={'/notification'}
            className="text-gray-500 hover:text-gray-700 relative"
          >
            {NotificationIcon}
            {notificationCount > 0 ? (
              <span className="absolute -top-1.5 -right-1.5 h-4 min-w-4 rounded-full text-white bg-red-500 flex items-center justify-center text-xs p-1">
                {notificationCount}
              </span>
            ) : (
              ''
            )}
          </Link>

          <div className="uk-inline">
            <button
              className="uk-button uk-button-default flex items-center gap-2 justify-between"
              type="button"
            >
              <span className="text-black font-medium text-sm capitalize  hidden sm:inline-block">
                Nass Store
              </span>
              <img
                src={'/assets/images/avatar-image.png'}
                alt="User"
                className="h-8 w-8 rounded-full"
              />
            </button>
            <div className="rounded-lg" data-uk-dropdown="pos: top-right">
              <ul className="uk-nav uk-dropdown-nav p-2 text-base">
                <li>
                  <button
                    type="button"
                    // uk-toggle="target: #common-modal"
                    onClick={logoutUser}
                    className="uk-button uk-button-default flex items-center gap-1.5 px-3 py-1 w-full text-sm rounded-lg text-red-600 hover:bg-primary-light capitalize"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#e7000b"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="feather feather-log-out"
                    >
                      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                      <polyline points="16 17 21 12 16 7"></polyline>
                      <line x1="21" y1="12" x2="9" y2="12"></line>
                    </svg>
                    Logout
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
